import { inject, Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';

@Pipe({
    name: 'getStreamClosingTypeNameById',
    standalone: false
})
export class GetStreamClosingTypeNameByIdPipe implements PipeTransform {
    dataService = inject(AppdataService);
    transform(id: string): string {
        let n = this.dataService.streamClosingTypes.find(type => type.id === id)?.name;
        return n ? n : id;
    }

}
